import React from 'react';
import { css, useTheme } from '@emotion/react';
import ReorderingSVG from '@birdi/icons/reordering.svg';
import type { WidgetProps } from '../tabs';

export interface ReorderingIconProps {
  isReorderMode?: boolean;
  isHovered?: boolean;
  isDragging?: boolean;
}

export const ReorderingIcon: React.FC<ReorderingIconProps> = ({
  isReorderMode,
  isHovered,
  isDragging,
}) => {
  const theme = useTheme();

  if (!isReorderMode || (!isHovered && !isDragging)) {
    return null;
  }

  return (
    <div
      css={css`
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        svg {
          width: 100%;
          height: 100%;
          color: ${theme.midnight};
        }
      `}
    >
      <ReorderingSVG />
    </div>
  );
};

